import { useSetFilter } from '../../filter';
import { ProductOrderKey } from '../domain';

export const useSetProductListOrder = () => {
  return useSetFilter(ProductOrderKey, 'productOrderBy', true);
};
